import { toast } from 'react-toastify';

import { getSerializedErrorMessage } from '../../../../../utils/errors';
import { finishTreatmentPlanV3Mutation, startTreatmentPlanV3Mutation } from '../../../utils';
import { isForLoadedAssessmentPage, markAssessmentPageChanged } from './utils';

import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import type { TreatmentPlanV3State } from '../../../types';
import type {
  AssessmentMutationAction,
  ITreatmentPlanV3AssessmentReadinessItemUpdate,
  TreatmentPlanV3AssessmentThunks,
  UpdateTreatmentPlanV3AssessmentReadinessItemPayload,
} from '../types';

export function addUpdateTreatmentPlanV3AssessmentReadinessItemCases(
  builder: ActionReducerMapBuilder<TreatmentPlanV3State>,
  thunks: TreatmentPlanV3AssessmentThunks,
) {
  const { updateTreatmentPlanV3AssessmentReadinessItem } = thunks;
  const flag = 'updateAssessmentReadinessItemLoading';

  builder
    .addCase(updateTreatmentPlanV3AssessmentReadinessItem.pending, (state, action) => {
      startTreatmentPlanV3Mutation(state, flag, action);
      state.assessmentReadinessItemRequestIds[action.meta.arg.item] = action.meta.requestId;
    })
    .addCase(
      updateTreatmentPlanV3AssessmentReadinessItem.fulfilled,
      (
        state,
        action: AssessmentMutationAction<
          ITreatmentPlanV3AssessmentReadinessItemUpdate,
          UpdateTreatmentPlanV3AssessmentReadinessItemPayload
        >,
      ) => {
        if (!finishTreatmentPlanV3Mutation(state, flag, action)) return;
        const itemId = action.meta.arg.item;
        if (action.meta.requestId !== state.assessmentReadinessItemRequestIds[itemId]) return;
        delete state.assessmentReadinessItemRequestIds[itemId];
        if (!isForLoadedAssessmentPage(state, action) || !state.assessmentPage) return;
        const list = state.assessmentPage.readiness_items;
        const { readiness_scores, item, readiness, notes } = action.payload;
        const nextItem = { item, readiness, notes };
        const index = list.findIndex((row) => row.item === item);
        markAssessmentPageChanged(state);
        if (index === -1) {
          list.push(nextItem);
        } else {
          list[index] = nextItem;
        }
        if (readiness_scores) {
          state.assessmentPage.readiness_scores = readiness_scores;
        }
      },
    )
    .addCase(updateTreatmentPlanV3AssessmentReadinessItem.rejected, (state, action) => {
      if (!finishTreatmentPlanV3Mutation(state, flag, action)) return;
      const itemId = action.meta.arg.item;
      if (action.meta.requestId !== state.assessmentReadinessItemRequestIds[itemId]) return;
      delete state.assessmentReadinessItemRequestIds[itemId];
      if (!isForLoadedAssessmentPage(state, action)) return;
      toast.error(getSerializedErrorMessage(action.error));
      state.error = action.error;
    });
}
